import React from 'react';
import gallery1 from '../img/gallery/gallery1.jpg';
import gallery2 from '../img/gallery/gallery2.jpg';
import gallery3 from '../img/gallery/gallery3.jpg';
import gallery4 from '../img/gallery/gallery4.jpg';
import gallery5 from '../img/gallery/gallery5.jpg';
import gallery6 from '../img/gallery/gallery6.jpg';
import gallery7 from '../img/gallery/gallery7.jpeg';
import gallery8 from '../img/gallery/gallery8.jpg';
import gallery9 from '../img/gallery/gallery9.jpg';
import gallery10 from '../img/gallery/gallery10.jpg';
import gallery11 from '../img/gallery/gallery11.jpeg';
import gallery12 from '../img/gallery/gallery12.jpeg';
import gallery13 from '../img/gallery/gallery13.jpg';
import gallery14 from '../img/gallery/gallery14.jpg';
import gallery15 from '../img/gallery/gallery15.jpg';
import gallery16 from '../img/gallery/gallery16.jpg';
import gallery17 from '../img/gallery/gallery17.jpg';
import gallery18 from '../img/gallery/gallery18.jpg';
import gallery19 from '../img/gallery/gallery19.jpg';
import gallery20 from '../img/gallery/gallery20.jpg';
import gallery21 from '../img/gallery/gallery21.jpg';
import gallery22 from '../img/gallery/gallery22.jpeg';
import gallery23 from '../img/gallery/gallery23.jpeg';
import gallery24 from '../img/gallery/gallery24.jpeg';
import gallery25 from '../img/gallery/gallery25.jpg';
import gallery26 from '../img/gallery/gallery26.jpg';
import gallery27 from '../img/gallery/gallery27.jpg';
import gallery28 from '../img/gallery/gallery28.jpg';
import gallery29 from '../img/gallery/gallery29.jpg';
import gallery30 from '../img/gallery/gallery30.jpg';

const images = [
  gallery1, gallery2, gallery3, gallery4, gallery5, gallery6,
  gallery7, gallery8, gallery9, gallery10, gallery11, gallery12,
  gallery13, gallery14, gallery15, gallery16, gallery17, gallery18,
  gallery19, gallery20, gallery21, gallery22, gallery23, gallery24,
  gallery25, gallery26, gallery27, gallery28, gallery29, gallery30,
];

const Gallery = () => {
  return (
    <div className="gallery-container">
      <h1 className="gallery-title">Галерея</h1>
      <div className="gallery-grid">
        {images.map((image, index) => (
          <div key={index} className="gallery-item">
            <img src={image} alt={`Фото ${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
